import { CompareListStatusItem, WishlistCheckboxItem } from '@navi-toolbox/ui-components';
import { NotificationTemplates } from './types';

export const notificationTemplateFactory = {
  [NotificationTemplates.WishList]: WishlistCheckboxItem,
  [NotificationTemplates.Compare]: CompareListStatusItem,
};
